// Cansdale is a web micro-site first: every screen has a real, shareable URL
// (/w/:shareToken is opened from an SMS or Instagram link), so this router uses
// web history and mounts the product routes flat at the root — no tab shell.

import { createRouter, createWebHistory } from '@ionic/vue-router';
import { PRODUCT_ROUTES, DESTINATION_ROUTES, HOME_ROUTE } from './product-routes.js';

const routes = PRODUCT_ROUTES.map((r) => ({
  path: r.path,
  name: r.id,
  component: r.component,
  props: true,
}));

const router = createRouter({
  history: createWebHistory(),
  routes: [...routes, { path: '/:pathMatch(.*)*', redirect: HOME_ROUTE }],
});

// main.js pushes HOME at boot. On the web that must be where the visitor
// already is — a shared /w/<token> link must not be bounced to the landing.
const here = typeof location !== 'undefined' ? location.pathname + location.search : HOME_ROUTE;
export const HOME = router.resolve(here).matched.length && router.resolve(here).name ? here : HOME_ROUTE;

// No tab bar: one destination is furniture, and this is a single-purpose site.
export const TABS = DESTINATION_ROUTES.slice(0, 0);

export default router;
